import { McaDrawer } from "../../mca/Drawer";
import { APIRequestFields } from "../../APIRequestFields";
import PostRequest from "../../../services/PostRequest";
import { showToaster } from "../../../common/common";
import { useDispatch, useSelector } from "react-redux";
import { getAsinList } from "../../../reducer/asin/Asin.action";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  fetchOfficeworksStores,
  postCodeDomainList,
  setZipCodeList,
} from "../../../reducer/zipCode/ZipCode.action";

export const AddSingleASIN = ({
  show,
  handleClose,
  setShowRequests,
  collectionId,
  isScrapModel = false,
  onCallback = false,
  requestType = "amazon",
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const _asinDetails = useSelector((state) => state.asinReducer.asinDetails);
  const _domainList = useSelector((state) => state.zipCodeReducer.domainList);

  const isOfficeworks = requestType === "officeworks";

  const handelAsinCreateAndUpdate = async (e) => {
    try {
      e.preventDefault();
      const formData = new FormData(e.target);

      var data = {};

      formData.forEach((value, key) => {
        data[key] = value;
      });

      data.collection = collectionId;

      const option = {
        showLoader: "add_signal_asin",
      };

      if (isOfficeworks) {
        if (_asinDetails) {
          data.sku_id = _asinDetails?.id;
          await PostRequest(`/schedules/officeworks/sku/update/`, data, option);
        } else {
          await PostRequest(`/schedules/officeworks/sku/create/`, data, option);
        }
      } else {
        if (_asinDetails) {
          data.asin_id = _asinDetails?.id;
        }

        if (isScrapModel) {
          const response = await PostRequest(
            `/schedules/asin/result/`,
            data,
            option
          );

          if (response && response.id) {
            navigate(`/collections`);
          } else {
            showToaster("Oops! Failed to scrap this asin, Please try again.");
          }
        } else {
          await PostRequest(
            `/schedules/asin/${_asinDetails ? "update" : "create"}/`,
            data,
            option
          );
        }
      }

      {
        _asinDetails && dispatch(getAsinList({ collection_id: params.id }));
      }

      const itemLabel = isOfficeworks ? "SKU" : "ASIN";
      showToaster(
        `${_asinDetails
          ? `${itemLabel} updated successfully.`
          : `Single ${itemLabel.toLowerCase()} added successfully.`
        }`
      );

      handleClose();
      setShowRequests(false);

      if (onCallback) {
        onCallback()
      }

    } catch (error) {
      console.log(error.message);
      showToaster(error.message, "error");
    }
  };

  useEffect(() => {
    dispatch(postCodeDomainList({ status: "active" }));
    if (isOfficeworks) {
      dispatch(fetchOfficeworksStores());
    }
  }, []);

  // Load zipcodes filtered by supplier domain once domain list is available
  useEffect(() => {
    if (!_domainList || _domainList.length === 0) return;

    if (isOfficeworks) {
      const owDomain = _domainList.find((d) => d.domain === "officeworks.com.au");
      if (owDomain) {
        dispatch(setZipCodeList({ status: "active", domain: owDomain.id }));
      }
    } else {
      // For Amazon, load all non-officeworks postcodes (no domain filter â€” Amazon has multiple domains)
      dispatch(setZipCodeList({ status: "active" }));
    }
  }, [_domainList, requestType]);

  const itemLabel = isOfficeworks ? "SKU" : "ASIN";

  const drawerTitle = _asinDetails
    ? `Edit ${itemLabel}`
    : isScrapModel
      ? `Scrap ${itemLabel}`
      : `Add Single ${itemLabel}`;

  return (
    <McaDrawer open={show} onClose={handleClose} title={drawerTitle}>
      <form onSubmit={handelAsinCreateAndUpdate}>
        <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
          <APIRequestFields requestType={requestType} />
        </div>

        <div className="mca-drawer__foot" style={{ marginTop: "24px" }}>
          <button
            type="button"
            className="mca-btn mca-btn--outline"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            id="add_signal_asin"
            type="submit"
            className="mca-btn mca-btn--primary"
          >
            Save
          </button>
        </div>
      </form>
    </McaDrawer>
  );
};
